export default __webpack_public_path__ + "static/media/avm-logo-200.93330d86.png";